import {ComplaintStatus} from "@/enums/status";
import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class ComplaintCustomerParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    status? = ComplaintStatus.ChuaXuLy;
    search?: string;
}